import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { AccordionStyled } from "assets/css/globle";
import EditSqrIcon from "assets/svgIcons/EditSqrIcon";
import {
  Heading,
  WorkSection,
  ActionWrapper,
} from "pages/Admin/SiteSettings/SettingStyled";
import { useSelector, useDispatch } from "react-redux";
import { mapHelpers } from "pages/Pins/utils/mapHelpers";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "@mui/material";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";

const CourseSettings = () => {
  const { t } = useTranslation();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const [courseData, setCourseData] = useState([]);
  const [changeDetector, setChangeDetector] = useState(true);
  const [courseDataBackup, setCourseDataBackup] = useState([]);
  const { siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];
    
  const [inputEnabler, setInputEnabler] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    let coursesList = [];
    if (
      siteSettingsData &&
      siteSettingsData?.Courses &&
      Object.keys(siteSettingsData?.Courses).length !== 0
    ) {
      siteSettingsData.Courses.forEach(function (crs) {
        coursesList.push({
          Name: crs?.Name,
          Number: crs?.Number,
          HoleCount: crs?.HoleCount,
          ColorRGB: crs?.ColorRGB
            ? "#" + mapHelpers.convIntToRGB(crs?.ColorRGB)
            : "#" +
            mapHelpers.convIntToRGB(
              mapHelpers.convRGBToInt(
                mapHelpers.getDefaultCourseColors(crs?.Number)
              )
            ),
          EzLocatorCourseId: crs?.EzLocatorCourseId
            ? crs?.EzLocatorCourseId
            : "",
          Id: crs?.Id,
          ShowTeeNameOnVDU: crs?.ShowTeeNameOnVDU,
          ShowTeeColorOnVDU: crs?.ShowTeeColorOnVDU
        });
      });
    }
    setCourseData(coursesList);
    setCourseDataBackup(coursesList);
  }, [siteSettingsData]);

  const saveNewCourseChanges = () => {
    let coursesList = [];
    if (courseData && courseData.length !== 0) {
      courseData.forEach(function (crs) {
        coursesList.push({
          Name: crs?.Name,
          Number: crs?.Number,
          HoleCount: crs?.HoleCount,
          ColorRGB: mapHelpers.convRGBToInt(crs?.ColorRGB.replace("#", "")),
          EzLocatorCourseId: crs?.EzLocatorCourseId,
          Id: crs?.Id,        
          ShowTeeNameOnVDU: crs?.ShowTeeNameOnVDU,
          ShowTeeColorOnVDU: crs?.ShowTeeColorOnVDU
        });
      });
    }

    if (coursesList && coursesList.length !== 0) {
      dispatch(COMMON_SERVICES.saveCourseChangesService(coursesList, siteId.get()));
    }
  };

  const modifyCourseData = (e, i, changeDetector) => {
    setChangeDetector(false);
    let tempData = [...courseData];
    if (changeDetector === "courseName") {
      tempData[i] = { ...tempData[i], Name: e.target.value };
      setCourseData(tempData);
    } else if (changeDetector === "courseColor") {
      tempData[i] = { ...tempData[i], ColorRGB: e.target.value };
      setCourseData(tempData);
    } else if (changeDetector === "ezLocator") {
      tempData[i] = { ...tempData[i], EzLocatorCourseId: e.target.value };
      setCourseData(tempData);
    }
  };

  return (
    <AccordionStyled>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Heading>
            <h3>{t("Course_Settings")}</h3>
          </Heading>
        </AccordionSummary>
        <AccordionDetails>
          <WorkSection>
              <table className="course-table">
                <tr>
                  <th>{t("Name")}</th>
                  <th>{t("Color")}</th>
                  <th>{t("ezlocator_course_id")}</th>
                </tr>
                {courseData && courseData.length !== 0 ? (
                  courseData.map((item, index) => (
                    <tr>
                      <td>
                        <input
                          // readOnly={inputEnabler}
                          disabled={inputEnabler}
                          style={{
                            cursor: inputEnabler ? "context-menu" : "auto",
                          }}
                          value={item?.Name}
                          onChange={(e) =>
                            modifyCourseData(e, index, "courseName")
                          }
                        />
                      </td>
                      <td>
                        <div
                          className="color-wrapper"
                          style={{
                            cursor: inputEnabler ? "no-drop" : "auto",
                          }}
                        >
                          <input
                            disabled={inputEnabler}
                            style={{ cursor: inputEnabler ? "no-drop" : "" }}
                            type="color"
                            value={item?.ColorRGB}
                            id="style1"
                            onChange={(e) =>
                              modifyCourseData(e, index, "courseColor")
                            }
                          />
                          {item?.ColorRGB}
                        </div>
                      </td>
                      <td>
                        {" "}
                        <input
                          style={{
                            cursor: inputEnabler ? "context-menu" : "auto",
                          }}
                          // readOnly={inputEnabler}
                          disabled={inputEnabler}
                          value={item?.EzLocatorCourseId}
                          onChange={(e) =>
                            modifyCourseData(e, index, "ezLocator")
                          }
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <></>
                )}
              </table>
              <ActionWrapper>
                {inputEnabler ? (
                  <Tooltip title={t("Edit")} arrow>
                    <span>
                      {" "}
                      <Button onClick={() => setInputEnabler(false)}>
                        <EditSqrIcon /> {t("Edit_Courses")}
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <>
                    <Tooltip title={t("Cancel_changes")} arrow>
                      <span>
                        {" "}
                        <Button
                          onClick={() => {
                            setCourseData(courseDataBackup);
                            setInputEnabler(true);
                          }}
                        >
                          {t("Cancel")}
                        </Button>
                      </span>
                    </Tooltip>
                    <Tooltip title={t("Save_changes")} arrow>
                      <span>
                        {" "}
                        <Button
                          disabled={changeDetector}
                          style={{
                            cursor: changeDetector ? "context-menu" : "pointer",
                          }}
                          className={changeDetector ? "" : "active"}
                          onClick={() => {
                            saveNewCourseChanges();
                            setInputEnabler(true);
                            setChangeDetector(true);
                          }}
                        >
                          {t("Save")}
                        </Button>
                      </span>
                    </Tooltip>
                  </>
                )}
              </ActionWrapper>
          </WorkSection>
        </AccordionDetails>
      </Accordion>
    </AccordionStyled>
  );
};

export default CourseSettings;
